// Utility functions for system messages

export const getTypeColor = (type) => {
  const colors = {
    info: "info",
    warning: "warning",
    announcement: "primary",
    violation: "error",
  };
  return colors[type] || "default";
};

export const getSeverityColor = (severity) => {
  const colors = {
    low: "success",
    medium: "warning",
    high: "error",
    critical: "error",
  };
  return colors[severity] || "default";
};

export const CATEGORIES = [
  { value: "profile_violation", label: "Profile Violation" },
  { value: "chat_violation", label: "Chat Violation" },
  { value: "content_violation", label: "Content Violation" },
  { value: "general", label: "General" },
  { value: "account", label: "Account" },
  { value: "feature", label: "Feature" },
  { value: "update", label: "Update" },
];

export const MESSAGE_TYPES = [
  { value: "info", label: "Info" },
  { value: "warning", label: "Warning" },
  { value: "announcement", label: "Announcement" },
  { value: "violation", label: "Violation" },
];

export const SEVERITY_LEVELS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];
